import React, { useState } from "react";
import { Row, Input, Button, message } from "antd";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import { updateAccountDetails } from "api/customApis";
import API_KEY from "api";

export default function PasswordField({ email, value, userId }) {
	const [editMode, setEditMode] = useState(false);
	const [data, setData] = useState({});
	const [loading, setLoading] = useState(false);
	const toggleMode = () => {
		setEditMode((e) => !e);
	};

	const onFieldChange = (e) => {
		setData({
			...data,
			[e.target.id]: e.target.value,
		});
	};

	const handleUpdate = () => {
		if (!data?.oldPassword) {
			message.error("Please enter your old password");
		} else if (!data?.newPassword) {
			message.error("Please enter your new password");
		}
		if (data.oldPassword && data.newPassword) {
			setLoading(true);
			API_KEY.URL.post(API_KEY.path.login, {
				email,
				password: data.oldPassword,
			})
				.then((_) => {
					updateAccountDetails(userId, { password: data.newPassword })
						.then((res) => {
							setLoading(false);
							setEditMode(false);
							message.success("Password updated successfully");
						})
						.catch(() => {
							setLoading(false);
							message.error(`Old password doesn't match, please try again`);
						});
				})
				.catch(() => {
					setLoading(false);
					message.error(`Old password doesn't match, please try again`);
				});
		}
	};

	const renderButtons = () => {
		return (
			<Row align="bottom" style={{ marginTop: "1rem", marginBottom: "1rem" }}>
				<Button
					size="large"
					style={{
						color: "white",
						backgroundColor: "#363E3D",
						width: 100,
						border: "1px solid white",
						borderRadius: 4,
					}}
					onClick={handleUpdate}
					loading={loading}
				>
					Update
				</Button>
				<Button
					size="large"
					style={{
						color: "#4F5655",
						backgroundColor: "white",
						width: 100,
						border: "1px solid #CDCFCE",
						borderRadius: 4,
						marginLeft: "1rem",
					}}
					onClick={() => {
						setEditMode(false);
					}}
				>
					Cancel
				</Button>
			</Row>
		);
	};

	const renderEditMode = () => {
		return (
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					justifyContent: "space-between",
				}}
			>
				<div
					style={{
						fontWeight: "bold",
						color: "#4F5655",
						marginBottom: "0.5rem",
					}}
				>
					Old Password
				</div>

				<Input.Password
					size="large"
					onChange={onFieldChange}
					value={data.oldPassword}
					id="oldPassword"
					iconRender={(visible) =>
						visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
					}
				/>
				<div
					style={{
						fontWeight: "bold",
						color: "#4F5655",
						marginBottom: "0.5rem",
						marginTop: "1rem",
					}}
				>
					New Password
				</div>

				<Input.Password
					size="large"
					onChange={onFieldChange}
					value={data.newPassword}
					id="newPassword"
					iconRender={(visible) =>
						visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
					}
				/>
				{renderButtons()}
			</div>
		);
	};

	const renderReadMode = () => {
		return (
			<>
				<div
					style={{
						display: "flex",
						flexDirection: "row",
						justifyContent: "space-between",
					}}
				>
					<div
						style={{
							fontWeight: "bold",
							color: "#4F5655",
							marginBottom: "0.5rem",
						}}
					>
						Password
					</div>
					{!editMode && (
						<div
							onClick={toggleMode}
							style={{
								paddingRight: "1rem",
								cursor: "pointer",
								color: "#0B7764",
							}}
						>
							Update
						</div>
					)}
				</div>
				<div style={{ color: "#040E0C", fontSize: 16 }}>********</div>
			</>
		);
	};

	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				borderBottom: "1px solid #E6E7E7",
				paddingTop: "1rem",
				paddingBottom: "1rem",
				width: window.innerWidth > 900 ? "70%" : "100%",
			}}
		>
			{editMode ? renderEditMode() : renderReadMode()}
		</div>
	);
}
